export default "__VITE_ASSET__CMv76IHH__"